import { Avatar } from "components/DesignSystem/AvatarGroup/Avatar";
import { Button } from "components/DesignSystem/Button/Button";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import InfoGray from "static/images/InfoGray.svg";
import { openFloatingChat, setToOpenChatId } from "store/slices/chat";
import { setScrollToMessageId } from "store/slices/messageToScrollTo";
import { MessageResponse } from "stream-chat";
import { DefaultStreamChatGenerics, useChatContext } from "stream-chat-react";
import { ItemCard } from "./HomeActionItems";
import * as Sentry from "@sentry/browser";

type CustomData = {
  transaction_count?: number;
};

export const RequestedInfoCustomTypeCard = ({
  messageId,
}: {
  messageId: string;
}) => {
  const { client } = useChatContext();
  const [message, setMessage] = useState<
    MessageResponse<DefaultStreamChatGenerics> | undefined
  >();

  const dispatch = useDispatch();
  const jumpToMsg = (message: MessageResponse) => {
    dispatch(setScrollToMessageId(message?.id));
    dispatch(setToOpenChatId(message?.channel?.id!));
    dispatch(openFloatingChat());
  };

  const getMessage = async (messageId: string) => {
    try {
      const { message } = await client.getMessage(messageId);
      if (message) {
        setMessage(message);
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };

  useEffect(() => {
    if (messageId) {
      getMessage(messageId);
    }
  }, [messageId]);

  if (!message) {
    return null;
  }

  const transactionCount =
    (message?.custom_data as CustomData)?.transaction_count || 0;

  return (
    <ItemCard
      handleClick={() => jumpToMsg(message!)}
      logo={<Avatar alt="" src={InfoGray} />}
      text={`Information requested for ${transactionCount} transactions`}
      description="Provide the necessary information to ensure accurate books"
      action={
        <Button customType="text" size="small">
          Add info
        </Button>
      }
    />
  );
};
